import { useState, useEffect } from 'react';
import { fetchCertifiers, createCertifier, updateCertifier, deleteCertifier } from '../services/certifierService';

export const useCertifiers = () => {
  const [certifiers, setCertifiers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadCertifiers = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchCertifiers();
      setCertifiers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const addCertifier = async (certifierData) => {
    try {
      setError(null);
      const newCertifier = await createCertifier(certifierData);
      setCertifiers(prev => [...prev, newCertifier]);
      return newCertifier;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const editCertifier = async (id, certifierData) => {
    try {
      setError(null);
      const updatedCertifier = await updateCertifier(id, certifierData);
      setCertifiers(prev => prev.map(certifier => certifier.id === id ? updatedCertifier : certifier));
      return updatedCertifier;
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  const removeCertifier = async (id) => {
    try {
      setError(null);
      await deleteCertifier(id);
      setCertifiers(prev => prev.filter(certifier => certifier.id !== id));
    } catch (err) {
      setError(err.message);
      throw err;
    }
  };

  useEffect(() => {
    loadCertifiers();
  }, []);

  return {
    certifiers,
    loading,
    error,
    loadCertifiers,
    addCertifier,
    editCertifier,
    removeCertifier
  };
};